import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";
const getToken = () => localStorage.getItem("token");

export const fetchCourses = async (id = null) => {
  try {
    const url = id
      ? `${process.env.REACT_APP_API_URL}/Library/Get-Courses-List?id=${id}`
      : `${process.env.REACT_APP_API_URL}/Library/Get-Courses-List`;

    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    // Assuming the API returns data in a consistent format
    return response.data.courses || response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};


export const getCourseDetail = async (id) => {
  try {
    const response = await api.get(`/Library/Get-Course-Detail?courseId=${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching course details:", error);
    throw error;
  }
};

export const addCourse = async (courseData) => {
  try {
    const response = await api.post("/Library/AddCourse", courseData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding course:", error);
    throw error;
  }
};
export const getBusinessGroups = async () => {
  try {
    const response = await api.get(API.businessGroup.getList);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBusinessGroupDetail = async (id) => {
  try {
    const response = await api.get(API.businessGroup.getDetails(id));
    console.log("Business Group Detail:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Business Group Detail:", error);
    throw error;
  }
};

export const addBusinessGroupField = async (field) => {
  try {
    const response = await api.post(API.businessGroupField.addBusinessGroupField, field);
    return response.data;
  }
  catch (error) {
    console.error("Error Adding Business Group Field", error);
    throw error;
  }
};
 
